import { FC, useEffect, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { yupSync } from '../../utils';
import { Loader } from '../Loader/Loader';
import close from '../../assets/RoundedClose.svg';
import * as Yup from 'yup';
import { useRequestDocumentsMutation } from '../../api/users';
import { FloatInput } from '../Fields/FloatInput';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    data: any;
    message: any;
    type?: string;
}

const validationSchema = Yup.object().shape({
    link: Yup.string()
        .matches(/^(https?:\/\/)/, 'Oops! Your link is not correct')
        .required('This is a required field')
        .test('link', 'This is a required field', (value) => {
            const passwordRegex = /[^\s]/;
            return passwordRegex.test(value);
        })
});

export const RequestDocumentModal: FC<ModalProps> = ({ openModal, setOpenModal, data, setTrigger, message, type }) => {
    const [form] = Form.useForm();
    const [isConfirmModal, setIsConfirmModal] = useState(false);
    const [requestDocuments, { data: successStatusData, isSuccess: StatusUpdatedSuccessfully, isLoading }] =
        useRequestDocumentsMutation();

    const handleFormSubmit = () => {
        form.validateFields()
            .then((values: any) => {
                if (isLoading) return;
                requestDocuments({
                    id: data.id,
                    data: {
                        tpa_link: values.link
                    }
                });
            })
            .catch(() => {
                return;
            });
    };

    useEffect(() => {
        if (StatusUpdatedSuccessfully && successStatusData) {
            message.success(successStatusData.message);
            setOpenModal(false);
            setTrigger(data.id);
        }
    }, [StatusUpdatedSuccessfully, successStatusData]);

    return (
        <>
            <Modal
                className="modal-modal"
                destroyOnClose
                centered
                open={openModal}
                onOk={() => handleFormSubmit()}
                onCancel={() => {
                    if (form.isFieldsTouched()) {
                        setIsConfirmModal(true);
                    } else {
                        setOpenModal(false);
                    }
                }}
                closeIcon={<img src={close} />}
                footer={
                    <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                        <Button
                            block
                            key="back"
                            onClick={() => {
                                if (form.isFieldsTouched()) {
                                    setIsConfirmModal(true);
                                } else {
                                    setOpenModal(false);
                                }
                            }}
                            className="cancel"
                        >
                            Cancel
                        </Button>
                        <Button block key="submit" type="primary" onClick={handleFormSubmit}>
                            {isLoading ? <Loader /> : 'Send'}
                        </Button>
                    </div>
                }
            >
                <div className="modal">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        {type === 'newTpa' ? (
                            <div className="modal__title">New TPA</div>
                        ) : (
                            <div className="modal__title">Request Documents</div>
                        )}
                    </div>

                    <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                        {type === 'newTpa' ? <></> : <div className="main__subtitle">Necessary company documents</div>}
                        {type === 'newTpa' ? (
                            <></>
                        ) : (
                            <ul>
                                <li>Financial Accounts</li>
                                <li>B-BBEE Affidavit / Certificate</li>
                                <li>SARS Letter of Good Standing</li>
                                <li>Company Registration Certificate</li>
                            </ul>
                        )}
                        <div className="main__subtitle" style={{ margin: '0 0 7px 0' }}>
                            Provide a link to the TPA
                        </div>

                        <Form form={form} onFinish={handleFormSubmit}>
                            <Form.Item name="link" rules={yupSync('link', validationSchema, true)}>
                                <FloatInput
                                    className="input"
                                    disabled={false ? true : false}
                                    floatLabel={'Link to TPA'}
                                    maxLength={512}
                                    hasError={() => !!form.getFieldError(['link']).length}
                                    required={true}
                                />
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </Modal>

            <Modal
                className={`confirmModal`}
                centered
                open={isConfirmModal}
                closeIcon={<div style={{ display: 'none', cursor: 'context-menu' }}></div>}
                width={600}
                footer={
                    <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                        <Button key="back" onClick={() => setIsConfirmModal(false)} block className="cancel">
                            Cancel
                        </Button>
                        <button
                            className="quit"
                            onClick={() => {
                                setOpenModal(false);
                                setIsConfirmModal(false);
                            }}
                        >
                            Quit
                        </button>
                    </div>
                }
            >
                <div className="modal-confirm">Your data won’t be saved! Are you sure you want to quit?</div>
            </Modal>
        </>
    );
};
